/** Writing direction of the UI. */
export type UiDirection = 'ltr' | 'rtl';

/** UI languages written right to left (the Extranet ships `ar`; the others are listed so a new
 *  `assets/i18n/<code>.json` for one of them flips the layout without touching this file). */
const RTL_LANGS: ReadonlySet<string> = new Set(['ar', 'fa', 'he', 'ur']);

/** Direction of a UI language code (`ar`, `ar-EG`, `AR` → `rtl`; anything else, empty included → `ltr`). */
export function directionOf(lang: string | null | undefined): UiDirection {
  const primary = (lang ?? '').trim().toLowerCase().split(/[-_]/)[0];
  return RTL_LANGS.has(primary) ? 'rtl' : 'ltr';
}

/**
 * The key as the reading direction sees it, for horizontal keyboard navigation (radiogroups,
 * segmented strips): in RTL the "next" option sits to the LEFT, so ArrowLeft means next and
 * ArrowRight previous (WAI-ARIA APG). Handlers switch on `readingKey(e.key, dir)` and keep their
 * LTR cases — ArrowRight = next — unchanged. Every other key passes through.
 */
export function readingKey(key: string, dir: UiDirection): string {
  if (dir !== 'rtl') return key;
  if (key === 'ArrowLeft') return 'ArrowRight';
  if (key === 'ArrowRight') return 'ArrowLeft';
  return key;
}
